var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cabecera'),(this.$store.state.contador == 0)?_c('login'):_vm._e(),(this.$store.state.contador == 1)?_c('principal'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }